<template>
  <UiContainer class="contacts-view" :max-width="1100">
    <h1 class="contacts-view__title">Контакты</h1>
    <p class="contacts-view__lead">
      Свяжитесь с нами по любым вопросам: подключение поставщиков, подбор оборудования, интеграции и
      поддержка.
    </p>

    <div class="contacts-view__grid">
      <UiCard class="contacts-view__card">
        <h2 class="contacts-view__card-title">Связаться с нами</h2>
        <div class="contacts-view__item">
          <span class="contacts-view__item-icon">📞</span>
          <div>
            <div class="contacts-view__item-main">+7 (951) 852-06-24</div>
            <div class="contacts-view__item-sub">Пн‑Пт, 9:00–18:00 (МСК)</div>
          </div>
        </div>
        <div class="contacts-view__item">
          <span class="contacts-view__item-icon">✉</span>
          <div>
            <div class="contacts-view__item-main">info@labactive.ru</div>
            <div class="contacts-view__item-sub">Ответ в течение рабочего дня</div>
          </div>
        </div>
      </UiCard>
    </div>
  </UiContainer>
</template>

<script setup lang="ts">
import UiCard from '@/shared/ui/UiCard.vue'
import UiContainer from '@/shared/ui/UiContainer.vue'
</script>

<style scoped>
.contacts-view {
  padding-top: 40px;
  padding-bottom: 64px;
}

.contacts-view__title {
  margin: 0 0 16px;
  font-size: 28px;
  font-weight: 700;
}

.contacts-view__lead {
  margin: 0 0 32px;
  font-size: 16px;
  color: #475569;
  line-height: 1.6;
}

.contacts-view__grid {
  display: grid;
  grid-template-columns: minmax(0, 560px);
  margin-bottom: 32px;
}

.contacts-view__card {
  padding: 24px;
}

.contacts-view__card-title {
  margin: 0 0 20px;
  font-size: 16px;
  font-weight: 600;
}

.contacts-view__item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 16px;
}

.contacts-view__item:last-child {
  margin-bottom: 0;
}

.contacts-view__item-icon {
  flex-shrink: 0;
  font-size: 20px;
}

.contacts-view__item-main {
  font-weight: 500;
}

.contacts-view__item-sub {
  font-size: 13px;
  color: #586578;
}
</style>
